import { useEffect, useMemo } from 'react';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { theme } from 'theme';
import { RouteList } from './Routes';
import { ModalManager } from 'views/Modals/ModalManager';
import { useDispatch } from 'react-redux';
import { AppDispatch } from 'store';
import { createBrowserHistory } from 'history';
import { BrowserRouter } from 'react-router-dom';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { fetchAppConfig } from 'thunks/appConfigThunk';
import GravityToken from 'components/common/GravityToken';
import './assets/styles/overflowStyles.css';
import './assets/styles/menuItemStyles.css';
import { getUserTogglesThunk } from 'reducers/userFeatureToggleReducer';
import useIgnoreResizeObserverError from 'components/hooks/useIgnoreResizeObserverError';
import '@zafire/foundations/design-tokens.css';
import '@zafire/foundations/variables.css';
import '@zafire/foundations/font-faces.css';
import { ZfWebComponentsConfig } from '@zafire/react';
import { QueryClientProvider } from '@tanstack/react-query';
import { getQueryClient } from './query-client';
import { AppToast } from './components/common/AppToast';
import { ZfToastProvider } from '@zafire/react';

const browserHistory = createBrowserHistory();

function App() {
  const dispatch = useDispatch<AppDispatch>();
  useIgnoreResizeObserverError();

  const queryClient = useMemo(() => getQueryClient(), []);

  useEffect(() => {
    dispatch(getUserTogglesThunk());
    dispatch(fetchAppConfig());
  }, [dispatch]);

  return (
    <ThemeProvider theme={theme}>
      <QueryClientProvider client={queryClient}>
        <ZfWebComponentsConfig>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <CssBaseline />
            <ModalManager />
            <GravityToken />
            <AppToast />
            <ZfToastProvider />
            {/* @ts-expect-error BrowserRouter history prop */}
            <BrowserRouter history={browserHistory}>
              <RouteList />
            </BrowserRouter>
          </LocalizationProvider>
        </ZfWebComponentsConfig>
      </QueryClientProvider>
    </ThemeProvider>
  );
}

export default App;
